import { render, staticRenderFns } from "./couponItemShadow.vue?vue&type=template&id=72b1209a&scoped=true"
import script from "./couponItemShadow.vue?vue&type=script&lang=js"
export * from "./couponItemShadow.vue?vue&type=script&lang=js"
import style0 from "./couponItemShadow.vue?vue&type=style&index=0&id=72b1209a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b1209a",
  null
  
)

export default component.exports